module.exports = __webpack_public_path__ + "img/LTC.afde79b0.png";